export default __webpack_public_path__ + "static/media/forsyth.85aa026f.jpeg";